import { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SWIPE_ROUTES = [
  '/',
  '/calculator',
  '/saved-maps',
  '/compare-maps',
  '/sky-state',
  '/knowledge-center',
];

export const useSwipeNavigation = (minSwipeDistance = 50) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);
  const [state, setState] = useState({ path: location.pathname, direction: 1 });

  if (state.path !== location.pathname) {
    setTouchStart(null);
    setTouchEnd(null);
    const currentIdx = SWIPE_ROUTES.indexOf(location.pathname);
    const prevIdx = SWIPE_ROUTES.indexOf(state.path);
    
    setState({
      path: location.pathname,
      direction: (currentIdx !== -1 && prevIdx !== -1 && currentIdx !== prevIdx) 
                  ? (currentIdx > prevIdx ? 1 : -1) 
                  : state.direction
    });
  }

  const onTouchStart = useCallback((e: TouchEvent | React.TouchEvent) => {
    const target = e.target as Element;
    if (target.closest && target.closest('[data-no-swipe="true"]')) {
      setTouchStart(null);
      setTouchEnd(null);
      return;
    }

    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  }, []);

  const onTouchMove = useCallback((e: TouchEvent | React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  }, []);

  const onTouchEnd = useCallback(() => {
    if (localStorage.getItem("page-swipe-disabled") === "true") return;
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe || isRightSwipe) {
      const currentPath = location.pathname;
      const currentIndex = SWIPE_ROUTES.findIndex(route => route === currentPath);

      if (currentIndex !== -1) {
        if (isLeftSwipe && currentIndex > 0) {
          navigate(SWIPE_ROUTES[currentIndex - 1]);
        } else if (isRightSwipe && currentIndex < SWIPE_ROUTES.length - 1) {
          navigate(SWIPE_ROUTES[currentIndex + 1]);
        }
      }
    }
  }, [touchStart, touchEnd, location.pathname, navigate, minSwipeDistance]);

  return {
    swipeHandlers: { onTouchStart, onTouchMove, onTouchEnd },
    direction: state.direction
  };
};
